import React, { useEffect, useState } from "react";
import { message, Card, Form, Select, Input, DatePicker, Row, Col, Button, Flex, Upload } from "antd";
import { dateFormat, menuLinks, notifyMessages, requiredMessages } from "../../utils/constants";
import { UploadOutlined } from "@ant-design/icons";
import { PageHeader } from "../../components/common/pageHeader";
import { Link,  useNavigate } from "react-router";
import { SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import DocumentsServices from "../../services/documentsServices";
import { useCurrentUserContext } from "../../context/currentUserContext";
import moment from 'moment';
import dayjs from 'dayjs';
import { handleDateConvertForApis } from "../../utils/functions";
import { fetchSuppliersList } from "../../state/slices/suppliersListSlice";


const NewDocument = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const { currentUser } = useCurrentUserContext();
    const dispatch = useDispatch();
    
    const divisionsList = useSelector(state => state.divisions.divisions);
    const suppliersList = useSelector(state => state.suppliers.suppliers);
    const anomaliesList = useSelector(state => state.anomalies.anomalies);
    const documentTypesList = useSelector(state => state.docTypes.docTypes);

    useEffect(() => {
        if (!currentUser) return;
        dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
    }, [dispatch, currentUser]);


    const beforeUpload = (file) => {
        //const { fileList } = this.state;
        setUploadedFile(file);
        setFileList([file]);
        //this.setState({ uploadedFile: file, fileList: fileList });
        return false;
    }

    const handleChange = (info) => {
        if (info.file.status === "removed") {
          setUploadedFile(null);
          setFileList([]);
        } else {
          setUploadedFile(info.file);
          setFileList([...info.fileList]);
          if (info.file.status === "done") {
            message.success(`${info.file.name} file uploaded successfully`);
          } else if (info.file.status === "error") {
            message.error(`${info.file.name} file upload failed.`);
          }
        }
      };

    const onRemove = () => {
        setUploadedFile(null);
        setFileList([]);
      };

    const saveData = async (values) => {
        const formData = new FormData();
        // Append document details as JSON string
        const documentData = {
            FluxName: values.fluxName || "",
            Plate: values.plate || "",
            DivisionID: values.divisionID || null,
            AnomalyID: values.anomalyID || null,
            SupplierID: values.supplierID || null,
            DocumentTypeID: values.documentTypeID || null,
            LastEditedUser: currentUser.id,
            Year: values.year ? parseInt(values.year) : null,
            Notes: values.notes || null,
            DateAdded: values.dateAdded
                ? handleDateConvertForApis(values.dateAdded)
                : null,
        };
        formData.append("Document", JSON.stringify(documentData));      
        if (uploadedFile) {
            formData.append("Attachment", uploadedFile);
        }
        setLoadingButton(true);
        try {
            
            const respData = await DocumentsServices.addDocument(formData);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                navigate(menuLinks.raportiControllo);
            } else {
                message.error(respData.ErrorDetail?.ErrorMessage || notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        }
        finally{
             setLoadingButton(false);
        }
    };
  
    const handleYearNumberInput = (e) => {
        const inputValue = e.target.value;
        const onlyNums = inputValue.replace(/\D/g, '');
        form.setFieldsValue({ year: onlyNums });
    };

    return (
        <div className="add-document">
            <PageHeader title={"Carica nuovo documento"} />

            <>
                <Card title="Dati documento" size="small" className="newDocCard">
                    <Form
                        id="addDocument"
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        style={{ maxWidth: 900, width: "100%" }}
                        onFinish={(values) => {saveData(values)}}
                        onValuesChange={() => setFieldsChanged(true)}
                    >
                        <Form.Item 
                            label="Tipo" 
                            name="documentTypeID" 
                            rules={[{ required: true, message: requiredMessages.requiredField }]}>                            
                            <Select 
                                placeholder="Tipo" 
                                options={documentTypesList} 
                                showSearch
                                optionFilterProp="label"                                
                            />
                        </Form.Item>

                        <Form.Item 
                            label="Targa impianto" 
                            name="plate" 
                            rules={[{ required: true, message: requiredMessages.requiredField }]}>
                           
                            <Input />
                        </Form.Item>

                        <Form.Item 
                            label="Batch" 
                            name="fluxName" >
                            
                            <Input />
                        </Form.Item>

                        <Form.Item 
                            label="Anomalie" 
                            name="anomalyID">
                            
                            <Select 
                                placeholder="Anomalie"  
                                options={anomaliesList} 
                                 showSearch
                                optionFilterProp="label"  
                            />
                        </Form.Item>

                        <Form.Item 
                            label="Divisione" 
                            name="divisionID" >
                            
                            <Select
                                placeholder="Divisione"
                                showSearch
                                optionFilterProp="label"
                                options={divisionsList} 
                            />
                        </Form.Item>

                        <Form.Item 
                            label="Manutentore" 
                            name="supplierID" 
                            rules={[{ required: true, message: requiredMessages.requiredField }]}>
                            
                            <Select 
                                placeholder="Manutentore" 
                                showSearch
                                optionFilterProp="label"
                                options={suppliersList} 
                            />
                        </Form.Item>

                        <Form.Item 
                            label="Data caricamento" 
                            name="dateAdded" 
                            rules={[{ required: true, message: requiredMessages.requiredField }]}
                            
                            >
                            
                            <DatePicker defaultValue={dayjs()} format={dateFormat} style={{ width: "100%" }} />
                        </Form.Item>

                        <Form.Item 
                            label="Anno" 
                            name="year" 
                            rules={[{ required: true, message: requiredMessages.requiredField}]}>
                            
                            <Input onChange={handleYearNumberInput} value={form.getFieldValue('year')}/>
                        </Form.Item>

                        <Form.Item
                             label="Carica pdf"
                             name="pdf"
                             rules={[{ required: true, message: requiredMessages.requiredField }]}
                             valuePropName="fileList"
                             getValueFromEvent={(e) => e && e.fileList}
                        >
                            <Upload
                                maxCount={1}
                                accept='.pdf'                                       
                                beforeUpload={beforeUpload}
                                fileList={fileList}
                                onChange={handleChange}
                                onRemove={onRemove}
                            >
                                <Button icon={<UploadOutlined />}>Seleziona PDF</Button>
                            </Upload>
                        </Form.Item>

                        <Form.Item 
                            label="Note" 
                            name="notes">
                            
                            <Input.TextArea rows={3} />
                        </Form.Item>
                    </Form>
                </Card>

                <Row gutter={24}>
                        <Col span={24} className="modifyDocButtons">
                            <Flex gap="small" wrap>
                                <Button type="default">
                                    <Link to={menuLinks.raportiControllo}>Annulla</Link>
                                </Button>

                                <Button
                                    loading={loadingButton}
                                    type="primary"
                                    htmlType="submit"
                                    disabled={!fieldsChanged}
                                    form="addDocument"
                                >
                                    <SaveOutlined /> Salva
                                </Button>
                            </Flex>
                        </Col>
                    </Row>
            </>
        </div>
    );
};

export default NewDocument;
